<template>
  <div class="materialAdmin">
    <div class="header">群欢迎语</div>
    <div class="header-menu">
      <div class="menu-left">
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新建群欢迎语</el-button
        >
      </div>
      <div class="menu-right">
        <el-input
          clearable
          class="search-ipt"
          placeholder="请输入关键字进行搜索"
          v-model="searchVal"
          @change="onSearch"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <div class="container">
      <el-table
        :data="tableData"
        border
        style="width: 100%; height: 60.0rem"
        max-height="600"
      >
        <el-table-column
          label="欢迎语类型"
          prop="type"
          width="160"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="欢迎语内容"
          prop="content"
        ></el-table-column>
        <el-table-column label="创建时间" width="280">
          <template slot-scope="scope">
            <span style="margin-left: 1.0rem">{{ scope.row.createtime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="320">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              style="color:#f00 !important"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :page-sizes="[10,20,50,100]"
        @pagination="getData"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import pagination from "@/components/Pagination";

export default {
  name: "mine",
  components: {
    pagination,
  },
  data() {
    return {
      searchVal: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      title: "",
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .post(
          "/crm/Assistant/getWelcome",
          qs.stringify({
            usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
            type: this.msgType,
            title: this.searchVal,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    onAdd() {
      this.$router.push({
        name: "groupWelcomeDetail",
      });
    },
    handleEdit(index, row) {
      this.$router.push({
        name: "groupWelcomeDetail",
        query: {
          id: row.id,
        },
      });
    },
    handleDelete(index, row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Assistant/delWelcome",
              qs.stringify({
                usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
                id: row.id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.tableData = [];
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onSearch() {
      this.getData();
    },
  },
};
</script>
<style  scoped>
.header {
  line-height: 4.0rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}
.header-menu {
  margin: 1.0rem 0 3.0rem 0;
  display: flex;
  justify-content: space-between;
}
.menu-right {
  display: flex;
  width: 22%;
}
.menu-select {
  margin-right: 1.2rem;
}

::v-deep .el-table__header-wrapper thead tr {
  background-color: #f2f2f2 !important;
  color: #fff;
}
</style>
